import api from './api';
import type {
  CustomerFaturamentoItemContract,
  CustomerFaturamentoListResponseContract,
  StatusFaturamentoCliente,
} from '@sstexames/shared-types';

export type {
  CustomerFaturamentoItemContract,
  CustomerFaturamentoListResponseContract,
  StatusFaturamentoCliente,
};

export interface ListFaturasParams {
  competencia?: string;
  ano?: string;
  status?: string;
}

export const faturamentoService = {
  async findAll(params?: ListFaturasParams): Promise<CustomerFaturamentoListResponseContract> {
    const response = await api.get<CustomerFaturamentoListResponseContract>('/faturamento', { params });
    return response.data;
  },

  async findOne(id: number): Promise<CustomerFaturamentoItemContract> {
    const response = await api.get<CustomerFaturamentoItemContract>(`/faturamento/${id}`);
    return response.data;
  },

  async downloadDocumento(id: number, tipo: 'espelho' | 'boleto' | 'nfse'): Promise<Blob> {
    const response = await api.get(`/faturamento/${id}/${tipo}`, {
      responseType: 'blob',
    });
    return response.data;
  },

  async abrirDocumento(id: number, tipo: 'espelho' | 'boleto' | 'nfse'): Promise<void> {
    const blob = await this.downloadDocumento(id, tipo);
    const contentType = 'text/html;charset=utf-8';
    const file = new Blob([blob], { type: contentType });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  },
};
